import React, { useContext } from 'react';
import { IconProps } from '../iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconWebm({
  isAutoscallable = true,
  sizeKey = '23x22',
  onClick,
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 23 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3685_63638"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="23"
        height="22"
      >
        <path d="M0.5 22V0H22.5V22H0.5Z" fill="white" />
      </mask>
      <g mask="url(#mask0_3685_63638)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.46094 21.0668V0.933167C3.46094 0.418001 3.87894 0 4.3941 0H12.5518L19.5368 6.985V21.0668C19.5368 21.582 19.1188 22 18.6037 22H4.3941C3.87894 22 3.46094 21.582 3.46094 21.0668Z"
          fill="#2B2B2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5508 -0.000625134L19.5358 6.98438H13.4839C12.9688 6.98438 12.5508 6.56637 12.5508 6.05121V-0.000625134Z"
          fill="#525252"
        />
        <path
          d="M8.97904 16.6107H9.4001L8.57999 19.4609H8.18765L7.5026 17.1583L6.82182 19.4609H6.43132L5.60938 16.6107H6.03043L6.6446 18.8547L7.30154 16.6107H7.71037L8.36487 18.8547L8.97904 16.6107Z"
          fill="#E6E6E6"
        />
        <path
          d="M11.4327 19.1185V19.457H9.73438V16.6111H11.4003V16.9454H10.1334V17.7954H11.33V18.1297H10.1334V19.1185H11.4327Z"
          fill="#E6E6E6"
        />
        <path
          d="M13.8696 18.6491C13.8696 18.9015 13.7682 19.1093 13.5653 19.2719C13.4082 19.3953 13.1687 19.457 12.8466 19.457H11.9238V16.6111H12.6914C13.0012 16.6111 13.2267 16.6563 13.3661 16.7461C13.5702 16.8775 13.6722 17.07 13.6722 17.3243C13.6722 17.4703 13.6307 17.6011 13.5482 17.7166C13.4657 17.8321 13.3624 17.9091 13.2389 17.9464V17.9568C13.4339 17.9983 13.5879 18.0778 13.7003 18.1963C13.8134 18.3143 13.8696 18.4652 13.8696 18.6491ZM13.2713 17.3701C13.2713 17.1971 13.2084 17.0755 13.0819 17.0059C12.9878 16.9533 12.8576 16.9276 12.6914 16.9295H12.3229V17.8315H12.6572C12.8637 17.8315 13.0055 17.8028 13.0819 17.7447C13.2084 17.6524 13.2713 17.5278 13.2713 17.3701ZM13.4589 18.6314C13.4589 18.4634 13.3899 18.3332 13.2512 18.2403C13.1491 18.1719 12.9829 18.1376 12.7519 18.1376H12.3229V19.1307H12.7519C12.9884 19.1307 13.1546 19.0977 13.2512 19.0323C13.3899 18.9382 13.4589 18.8044 13.4589 18.6314Z"
          fill="#E6E6E6"
        />
        <path
          d="M17.1072 16.6111L17.367 19.457H16.9703L16.7852 17.2093H16.773L15.9027 19.4814H15.6754L14.8052 17.2093H14.793L14.6115 19.457H14.2148L14.4709 16.6111H14.9665L15.786 18.8086H15.7958L16.6159 16.6111H17.1072Z"
          fill="#E6E6E6"
        />
      </g>
    </svg>
  );
}

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="23"
  height="22"
  viewBox="0 0 23 22"
  fill="none"
>
  <mask
    id="mask0_3685_63638"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="23"
    height="22"
  >
    <path d="M0.5 22V0H22.5V22H0.5Z" fill="white" />
  </mask>
  <g mask="url(#mask0_3685_63638)">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.46094 21.0668V0.933167C3.46094 0.418001 3.87894 0 4.3941 0H12.5518L19.5368 6.985V21.0668C19.5368 21.582 19.1188 22 18.6037 22H4.3941C3.87894 22 3.46094 21.582 3.46094 21.0668Z"
      fill="#2B2B2B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5508 -0.000625134L19.5358 6.98438H13.4839C12.9688 6.98438 12.5508 6.56637 12.5508 6.05121V-0.000625134Z"
      fill="#525252"
    />
    <path
      d="M8.97904 16.6107H9.4001L8.57999 19.4609H8.18765L7.5026 17.1583L6.82182 19.4609H6.43132L5.60938 16.6107H6.03043L6.6446 18.8547L7.30154 16.6107H7.71037L8.36487 18.8547L8.97904 16.6107Z"
      fill="#E6E6E6"
    />
    <path
      d="M11.4327 19.1185V19.457H9.73438V16.6111H11.4003V16.9454H10.1334V17.7954H11.33V18.1297H10.1334V19.1185H11.4327Z"
      fill="#E6E6E6"
    />
    <path
      d="M13.8696 18.6491C13.8696 18.9015 13.7682 19.1093 13.5653 19.2719C13.4082 19.3953 13.1687 19.457 12.8466 19.457H11.9238V16.6111H12.6914C13.0012 16.6111 13.2267 16.6563 13.3661 16.7461C13.5702 16.8775 13.6722 17.07 13.6722 17.3243C13.6722 17.4703 13.6307 17.6011 13.5482 17.7166C13.4657 17.8321 13.3624 17.9091 13.2389 17.9464V17.9568C13.4339 17.9983 13.5879 18.0778 13.7003 18.1963C13.8134 18.3143 13.8696 18.4652 13.8696 18.6491ZM13.2713 17.3701C13.2713 17.1971 13.2084 17.0755 13.0819 17.0059C12.9878 16.9533 12.8576 16.9276 12.6914 16.9295H12.3229V17.8315H12.6572C12.8637 17.8315 13.0055 17.8028 13.0819 17.7447C13.2084 17.6524 13.2713 17.5278 13.2713 17.3701ZM13.4589 18.6314C13.4589 18.4634 13.3899 18.3332 13.2512 18.2403C13.1491 18.1719 12.9829 18.1376 12.7519 18.1376H12.3229V19.1307H12.7519C12.9884 19.1307 13.1546 19.0977 13.2512 19.0323C13.3899 18.9382 13.4589 18.8044 13.4589 18.6314Z"
      fill="#E6E6E6"
    />
    <path
      d="M17.1072 16.6111L17.367 19.457H16.9703L16.7852 17.2093H16.773L15.9027 19.4814H15.6754L14.8052 17.2093H14.793L14.6115 19.457H14.2148L14.4709 16.6111H14.9665L15.786 18.8086H15.7958L16.6159 16.6111H17.1072Z"
      fill="#E6E6E6"
    />
  </g>
</svg>;
